import React from "react";
import UnattendedAccessTermsVersionList from "../../components/event/UnattendedAccessTermsVersionList";

const UnattendedAccessTermsVersionsPage = () => {
    return <UnattendedAccessTermsVersionList/>
}

export default UnattendedAccessTermsVersionsPage;
